module.exports = require("./fr-TN.d.ts");